<template>
  <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="19.433" height="18.218" viewBox="0 0 19.433 18.218">
    <g transform="translate(-1053.142 -404.764)">
      <path class="a"
            d="M9.858,20.253a1.822,1.822,0,1,1-1.822-1.822A1.822,1.822,0,0,1,9.858,20.253Zm12.146,0a1.822,1.822,0,1,1-1.822-1.822A1.822,1.822,0,0,1,22,20.253Zm0-7.895V5.071H7.429A1.215,1.215,0,0,0,6.214,3.856H2.571V5.071H5l.912,7.82a2.429,2.429,0,0,0,1.517,4.326H22V16H7.429a1.215,1.215,0,0,1-1.215-1.215s0-.008,0-.012L22,12.358Z"
            transform="translate(1050.571 400.907)"/>
      <line class="b" y2="4.468" transform="translate(1064.376 408.139)"/>
      <line class="b" y2="4.468" transform="translate(1066.609 410.373) rotate(90)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "CartPlus"
}
</script>

<style scoped>
.icon .a {
  fill:#00a2f8;
}

.icon .b {
  fill:none;
  stroke:#fff;
  stroke-linecap:round;
  stroke-width:2px;
}
</style>